<template>
  <div class="login">
    <!-- 公共头部 -->
    <v-header :isShow="isShow"></v-header>
    <!-- 账号密码登陆 -->
    <v-content>
      <div class="logCont">
        <h2 class="center">个人<br>管理平台</h2>
        <div class="center logWrap">
          <div class="alert alert-info">
            请以员工工号做为用户名登录
          </div>
          <div class="logInfo">
            <!-- 登陆 -->
            <div class="input-prepend" title="工号">
              <span class="add-on"><i class="icon-user"></i></span>
              <input type="text" class="input-large" id="usercode" name="usercode" placeholder="工号" v-model="username">
            </div>
            <!-- 密码 -->
            <div class="input-prepend" title="密码">
              <span class="add-on"><i class="icon-lock"></i></span>
              <input type="password" class="input-large" id="password" name="password" placeholder="密码" v-model="password">
            </div>
            <!-- 验证码 -->
            <div class="input-prepend" title="验证码">
              <span class="add-on"><i class="icon-picture"></i></span>
              <input type="text" class="input-small" id="captcha" name="captcha" placeholder="验证码" v-model="code" >
              <!-- @keyup="show($event)" -->
              <span class="imgCode" @click="change"><img id="captchapic" :src="imgCode"></span>
            </div>
            <!-- 按钮 -->
            <p class="center span5">
              <button type="submit" class="btn btn-primary" @click="login">登录</button>
            </p>
            <!-- <p class="warnX">
              <el-collapse-transition>
                  <div v-show="show3">
                    <div class="transition-box">{{falseHints}}</div>
                  </div>
              </el-collapse-transition>
            </p>   -->
          </div>
        </div>
        <p align="center" class="logP"><a href="http://beian.miit.gov.cn" target="_blank"> ©2015 京ICP备15003316号</a></p>
      </div>
    </v-content>
  </div>
</template>
<script>
export default {
  name: 'home'
}
</script>